<script setup lang="ts">
import type { ApiToken } from '../../model/api-tokens/interfaces'

import { faPen, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useApiTokenActions } from '../../model/api-tokens/api-token-actions.hook'

defineOptions({
  name: 'ApiTokenActions',
})

const props = defineProps<{
  token: ApiToken
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  toggle,
  openEdit,
  openDelete,
} = useApiTokenActions({
  token: computed(() => props.token),
})
</script>

<template>
  <div
    ref="containerRef"
    class="api-token-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for token ${token.name}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="api-token-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Edit"
          color="blue"
          :prepend-icon="faPen"
          @click="openEdit"
        />
        <AppDropdownItem
          text="Delete"
          color="red"
          :prepend-icon="faTrashCan"
          @click="openDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./ApiTokenActions.scss" />
